import React from 'react';
import EventCard from '../EventCard';
import type { EventData } from '../../types/events';

const MDQ_EVENTS: EventData[] = [
  {
    id: 'mdq-fri-11',
    venue: 'mdq',
    venueName: 'Museum MDQ',
    title: '🌊 RAKKATTA',
    subtitle: 'Noche Chandon 🥂✨',
    date: '2026-09-11',
    dateLabel: '11/09',
    dayLabel: 'Viernes',
    gradientClass: 'gradient-mdq-chandon',
    accentColor: '#00d4ff',
    borderColor: 'rgba(0, 212, 255, 0.6)',
    glowColor: 'rgba(0, 212, 255, 0.35)',
    featuredBanner: '🥂 Descuentos exclusivos Noche de Chandon — 1 Chandon $45.000!',
  },
  {
    id: 'mdq-sat-12',
    venue: 'mdq',
    venueName: 'Museum MDQ',
    title: '🌊 BENJI GRAMITOS 🇨🇱',
    subtitle: 'Speed Líder Live Show 🎤🔥',
    date: '2026-09-12',
    dateLabel: '12/09',
    dayLabel: 'Sábado',
    gradientClass: 'gradient-mdq-benji',
    accentColor: '#bf5fff',
    borderColor: 'rgba(191, 95, 255, 0.6)',
    glowColor: 'rgba(191, 95, 255, 0.35)',
    featuredBanner: '✨ SHOW INTERNACIONAL!',
  },
  {
    id: 'mdq-fri-18',
    venue: 'mdq',
    venueName: 'Museum MDQ',
    title: '🌊 RAKKATTA',
    subtitle: 'Sports Night ⚽🏆',
    date: '2026-09-18',
    dateLabel: '18/09',
    dayLabel: 'Viernes',
    gradientClass: 'gradient-mdq-sports',
    accentColor: '#7c3aff',
    borderColor: 'rgba(124, 58, 255, 0.6)',
    glowColor: 'rgba(124, 58, 255, 0.35)',
  },
  {
    id: 'mdq-sat-19',
    venue: 'mdq',
    venueName: 'Museum MDQ',
    title: '🌊 SIMON LA LETRA 🇨🇱',
    subtitle: 'Live Show 🎤🔥',
    date: '2026-09-19',
    dateLabel: '19/09',
    dayLabel: 'Sábado',
    gradientClass: 'gradient-mdq-simon',
    accentColor: '#ff2d6b',
    borderColor: 'rgba(255, 45, 107, 0.6)',
    glowColor: 'rgba(255, 45, 107, 0.35)',
    featuredBanner: '✨ SHOW INTERNACIONAL!',
  },
  {
    id: 'mdq-sun-20',
    venue: 'mdq',
    venueName: 'Museum MDQ',
    title: '🌊 TERRIBLE DOMINGO',
    subtitle: 'Spring Break 🌸🍹',
    date: '2026-09-20',
    dateLabel: '20/09',
    dayLabel: 'Domingo',
    gradientClass: 'gradient-mdq-domingo1',
    accentColor: '#00ffcc',
    borderColor: 'rgba(0, 255, 204, 0.6)',
    glowColor: 'rgba(0, 255, 204, 0.35)',
  },
  {
    id: 'mdq-fri-25',
    venue: 'mdq',
    venueName: 'Museum MDQ',
    title: '🌊 RAKKATTA',
    subtitle: 'Smirnoff House 🍾🎧',
    date: '2026-09-25',
    dateLabel: '25/09',
    dayLabel: 'Viernes',
    gradientClass: 'gradient-mdq-smirnoff',
    accentColor: '#ffcc00',
    borderColor: 'rgba(255, 204, 0, 0.6)',
    glowColor: 'rgba(255, 204, 0, 0.35)',
  },
  {
    id: 'mdq-sat-26',
    venue: 'mdq',
    venueName: 'Museum MDQ',
    title: '🌊 LUCIANO TRONCOSO',
    subtitle: 'Set Live 🎧🔥',
    date: '2026-09-26',
    dateLabel: '26/09',
    dayLabel: 'Sábado',
    gradientClass: 'gradient-mdq-luciano',
    accentColor: '#ff00ff',
    borderColor: 'rgba(255, 0, 255, 0.6)',
    glowColor: 'rgba(255, 0, 255, 0.35)',
  },
  {
    id: 'mdq-sun-27',
    venue: 'mdq',
    venueName: 'Museum MDQ',
    title: '🌊 TERRIBLE DOMINGO',
    subtitle: 'Guaracha 100% 🎶🔥',
    date: '2026-09-27',
    dateLabel: '27/09',
    dayLabel: 'Domingo',
    gradientClass: 'gradient-mdq-guaracha',
    accentColor: '#ff00aa',
    borderColor: 'rgba(255, 0, 170, 0.6)',
    glowColor: 'rgba(255, 0, 170, 0.4)',
    featuredBanner: '✨ LA NOCHE MAS ESPERADA — GUARACHA 100%',
  },
];

interface MuseumMdqTabProps {
  openListaFree: (event: EventData) => void;
}

export default function MuseumMdqTab({ openListaFree }: MuseumMdqTabProps) {
  return (
    <div className="animate-fade-in">
      {/* Neon Venue Header */}
      <div className="mb-6 text-center px-2">
        <h2
          className="text-5xl sm:text-6xl font-black tracking-tight uppercase leading-none"
          style={{
            color: '#fff',
            textShadow: '0 0 20px #fff, 0 0 50px rgba(255,255,255,0.6), 0 0 80px rgba(191,95,255,0.4)',
          }}
        >
          MUSEUM
        </h2>
        <p
          className="text-xl sm:text-2xl font-black tracking-[0.35em] uppercase mt-1"
          style={{
            color: '#00d4ff',
            textShadow: '0 0 14px #00d4ff, 0 0 30px rgba(0,212,255,0.7), 0 0 50px rgba(0,212,255,0.4)',
          }}
        >
          MAR DEL PLATA
        </p>
        <div
          className="my-4 h-px w-full"
          style={{
            background: 'linear-gradient(90deg, transparent, #00d4ff, #bf5fff, #ff00aa, #bf5fff, #00d4ff, transparent)',
            boxShadow: '0 0 10px rgba(0,212,255,0.8), 0 0 20px rgba(191,95,255,0.5)',
          }}
        />
        <p
          className="text-sm sm:text-base font-extrabold tracking-widest uppercase"
          style={{ color: '#bf5fff', textShadow: '0 0 12px #bf5fff, 0 0 24px rgba(191,95,255,0.6)' }}
        >
          LINE UP SEPTIEMBRE #2026
        </p>
        <p className="text-xs sm:text-sm text-muted-foreground mt-1 font-medium">
          PRÓXIMAS FECHAS – TOCÁ UNA PARA ANOTARTE O RESERVAR
        </p>
      </div>

      {/* Event List */}
      <div className="flex flex-col gap-3">
        {MDQ_EVENTS.map((event) => (
          <EventCard key={event.id} event={event} onListaFree={openListaFree} />
        ))}
      </div>
    </div>
  );
}